import Title from '@/components/Title'
import React from 'react'

const ChampionshipsSucceeded = (): React.ReactElement => {
  return (
    <div>
      <Title type='h2' theme='h3'>
        Успех!
      </Title>
      <div>Заявка на создание чемпионата успешно отправлена. На указанную почту Вам придут дальнейшие инструкции</div>
    </div>
  )
}

export default ChampionshipsSucceeded
